import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Franchise.css'; // Importing custom CSS

const FranchiseList = () => {
  const [franchises, setFranchises] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch franchises from API
  useEffect(() => {
    const fetchFranchises = async () => {
      try {
        const response = await axios.get('/auth/franchise/list');
        if (response.data.success) {
          setFranchises(response.data.franchises);
        } else {
          setError('Failed to load franchises');
        }
      } catch (error) {
        setError('Error fetching franchises');
      } finally {
        setIsLoading(false);
      }
    };

    fetchFranchises();
  }, []);

  return (
    <div className="franchise-container">
      <h1 className="title">Franchise List</h1>
      {isLoading && <p className="loading">Loading...</p>}
      {error && <p className="error">{error}</p>}
      {franchises.length === 0 && !isLoading && <p>No franchises found.</p>}
      
      {!isLoading && !error && franchises.length > 0 && (
        <table className="franchise-table">
          <thead>
            <tr>
              <th className="table-header">Franchise Name</th>
              <th className="table-header">Location</th>
            </tr>
          </thead>
          <tbody>
            {franchises.map((franchise) => (
              <tr key={franchise._id}>
                <td className="table-cell">{franchise.name}</td>
                <td className="table-cell">{franchise.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FranchiseList;
